import React, { PropsWithChildren, useEffect, useState } from 'react';
import Container from '@/components/container';
import TabNav, { menuItemsType } from '@/components/slide-menu/tab-nav';
import DetailHeaderInfoWrapper from '@/components/detail-header-info-wrapper';
import { useSlideMenuCollapse } from '@/hooks/useSlideMenuCollapsedChange';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';
import { getQuery } from '@/common/utils';
import roomApis from '@/apis/room/index';
import wareApis from '@/apis/ware/index';
import { message, Tooltip, Button } from 'antd';
import { updateCrumbs } from '@/components/bread-crumbs';
import { CopyOutlined } from '@ant-design/icons';
import Copy from '@/components/copy';
import JdImg from '@/components/jd-img';
import { formateTimeStamp } from '@/common/utils';
import useHideBreadCrumbs from '@/components/bread-crumbs/use-hide-bread-crumbs';
import BtnPowerManage from '../components/btn-authority-management';
import { useHistory } from 'react-router-dom';
import cateApi from '@/apis/cate/index';
import { QuestionCircleOutlined } from '@ant-design/icons';
interface DailyActivityDetailsProps {
  tag?: number;
}

function DailyActivitiesDetailsManager(props: PropsWithChildren<DailyActivityDetailsProps>) {
  const [dailyData, setDailyData] = useState<any | undefined>({});
  const [poolData, setPoolData] = useState<any | undefined>({});
  const [strategyData, setStrategyData] = useState<any | undefined>({});
  const [permission, setPermission] = useState<any | undefined>({});
  const [showHeader, setShowHeader] = useState(true);
  const [showNav, setShowNav] = useState(true);
  const [headerExtraProps, setHeaderExtraProps] = useState<any | undefined>({});
  const history = useHistory();
  const activityId = getQuery('activityId');
  const blockId = getQuery('blockId');
  const jobId = Number(getQuery('jobId'));

  const getExtra = () => {
    if (!!headerExtraProps.renderCrumbs) return [];
    if (blockId) {
      return [
        {
          key: '收品池编号',
          value: (
            <Copy key="blockId" text={blockId} icon={<CopyOutlined className="activity-card-detail__icon-copy" />} />
          ),
        },
        {
          key: '素材组编号',
          value: (
            <Copy
              key="otherSystemGroupId"
              text={poolData.otherSystemGroupId}
              icon={<CopyOutlined className="activity-card-detail__icon-copy" />}
            />
          ),
        },
        {
          key: '收品类型',
          value: poolData.gatherType,
        },
        {
          key: '示意图',
          value: !!poolData.imageUrl ? (
            <Tooltip
              key="image"
              overlayStyle={{ minWidth: 260 }}
              title={<JdImg className="venue_jd_img" src={poolData.imageUrl} width="100%" height={147} />}
            >
              <a>查看</a>
            </Tooltip>
          ) : (
            '-'
          ),
        },
        {
          key: '收品池介绍',
          value: poolData.description,
        },
      ];
    }
    return [
      {
        key: '管理组组长',
        value: dailyData.leader,
      },
      {
        key: '活动ID',
        value: activityId,
      },
      {
        key: '活动时间',
        value: `${formateTimeStamp(dailyData.startTime, true)} 至 ${formateTimeStamp(dailyData.endTime, true)}`,
      },
    ];
  };

  useEffect(() => {
    if (!activityId) {
      setDailyData({});
      return;
    }
    roomApis.getDetailByRoomId({ activityId }).then(({ ret, data, msg }: any = {}) => {
      if (ret === '0') {
        cateApi.list({ pageSize: 100 }).then((res: any) => {
          if (ret === '0') {
            const dailyDatas = Object.assign({}, data, {
              categoryName:
                data.category &&
                data.category
                  .map((item: any) => res.data.categorys.find((cate: any) => cate.categoryId === Number(item)))
                  .filter((item: any) => item !== undefined)
                  .map((item: any) => item.categoryName),
            });
            setDailyData(dailyDatas);
          }
        });
      } else {
        message.error(msg);
      }
    });
  }, [activityId]);

  useEffect(() => {
    if (!activityId || !blockId) {
      setPoolData({});
      return;
    }
    roomApis
      .poolHeader({
        tibaoId: activityId,
        poolId: blockId,
      })
      .then(({ ret, msg, data }) => {
        if (ret === '0') {
          setPoolData(data);
        } else {
          message.error(msg);
        }
      });
  }, [activityId, blockId]);

  useEffect(() => {
    if (!dailyData.roomId || !jobId) {
      setStrategyData({});
      return;
    }
    wareApis
      .goodsStrategyList({
        channelId: dailyData?.roomId,
        channelType: 11,
        jobId,
        pageNo: 1,
        pageSize: 10,
      })
      .then(({ ret, data, msg }) => {
        if (ret === '0') {
          setStrategyData(data?.data[0]);
        } else {
          message.error(msg);
        }
      });
  }, [jobId, dailyData.roomId]);

  useEffect(() => {
    let roomId = dailyData?.roomId;
    if (!roomId) return;
    roomApis.dailyActPermission({ roomId }).then(({ ret, msg, data }) => {
      if (ret === '0') {
        setPermission(data);
      } else {
        message.error(msg);
      }
    });
  }, [dailyData.roomId]);
  // 路由相关
  useEffect(() => {
    const data = {
      dailyData,
      poolData,
      strategyData,
    };
    // 离开当前页面清除面包屑的数据
    return updateCrumbs(data);
  });

  useSlideMenuCollapse();

  useHideBreadCrumbs();

  const getStyle = () => (showNav ? {} : { style: { width: '100%' } });

  const tabData = [
    {
      title: (
        <div>
          素材创建
          <Tooltip
            placement="right"
            title="通过分配提报（原提报流程）、规则直选（直接选品）等方式生成商品组/广告组关联前台页面"
          >
            <QuestionCircleOutlined style={{ marginLeft: 4 }} />
          </Tooltip>
        </div>
      ),
      order: 1,
      key: 'material_selector',
      path: `/activity-manage/myCreate/daily-activities-manager/materials?activityId=${activityId}&id=${activityId}&receivingType=1`,
    },
    {
      title: '商品策略',
      order: 2,
      key: 'shop_strategy',
      path: `/activity-manage/myCreate/daily-activities-manager/strategy?entry=0&activityId=${activityId}&from=acore&hideTab=1&id=${activityId}`,
    },
    {
      title: '前台页面',
      order: 3,
      key: 'tower_activity',
      path: `/activity-manage/myCreate/daily-activities-manager/tower-activity?entry=0&activityId=${activityId}&from=acore&hideTab=1&id=${activityId}`,
    },
  ];

  function getTab() {
    if (!permission?.modules?.tabs) return;
    const tab = permission.modules?.tabs;
    const result = [];
    for (let i in tab) {
      if (tab[i] === 1) {
        result.push(tabData.find((item) => item.key === i));
      }
    }
    return result.filter((item) => item !== undefined).sort((a: any, b: any) => a.order - b.order);
  }

  const headerPermission = permission?.modules?.functions?.room_header;

  return (
    <ContextProviderMenus.Provider
      value={{
        children: props.children,
        setShowHeader,
        setShowNav,
        setHeaderExtraProps,
        roomId: dailyData.roomId,
        activityId: activityId,
        dailyData,
        permission,
      }}
    >
      <Container bg={false} padding={false} margin={false}>
        {showHeader && (
          <DetailHeaderInfoWrapper
            extraInfo={getExtra()}
            btns={
              <>
                {headerPermission?.room_member_management === 1 && <BtnPowerManage roomId={dailyData.roomId} />}
                {headerPermission?.room_info_modify === 1 && (
                  <Button
                    shape="round"
                    type="primary"
                    onClick={() => {
                      history.push(
                        `/activity-manage/myCreate/acoreCreateRoomActivity?roomId=${dailyData.roomId}&activityId=${activityId}`
                      );
                    }}
                    ghost
                  >
                    修改活动
                  </Button>
                )}
              </>
            }
            onBack={() => {
              if (blockId || window.location.href.includes('poolSetting')) {
                history.push(
                  `/activity-manage/myCreate/daily-activities-manager/materials?activityId=${activityId}&id=${activityId}&receivingType=1`
                );
                return;
              }
              history.push('/activity-manage/myCreate/room/activityReceipt');
            }}
            {...headerExtraProps}
          />
        )}
        <div style={{ display: 'flex' }}>
          {showNav && <TabNav layout="vertical" sticky={true} menuItems={getTab() as Array<menuItemsType>} />}
          <div className="venue__wrapper__right" {...getStyle()}>
            {props.children}
          </div>
        </div>
      </Container>
    </ContextProviderMenus.Provider>
  );
}

export default DailyActivitiesDetailsManager;
